<template>
  <div id="populationLeftThree" class="echarts"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
import { marital } from "@/api/dataAnalysis/populationAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      regionId: 0,
      obj: []
    });
    const refData = toRefs(data);
    const maritallist = async () => {
      const res = await marital(data.regionId);
      res.data.forEach((v) => {
        data.obj.push({ value: v.value, name: v.name });
      });
    };

    onMounted(async () => {
      data.regionId = JSON.parse(localStorage.getItem("regionId"));
      await maritallist();
      // echarts项目初始化
      const colorList = ["#5B8FF9", "#5AD8A6",
        "#5D7092", "#F6BD16", "#E8684A", "#6DC8EC",
        "#9270CA", "#FF9D4D", "#269A99", "#FF99C3"];
      // const colorList = ["#FF99C3", "#269A99"];
      const myChart = echarts.init(
        document.getElementById("populationLeftThree")
      );
      myChart.setOption({
        // title: {
        //   text: "Referer of a Website",
        //   subtext: "Fake Data",
        //   left: "center",
        // },
        color: colorList,
        tooltip: {
          trigger: "item"
        },
        // legend: {
        //   orient: "vertical",
        //   left: "left",
        // },

        series: [
          {
            name: "未婚",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            // radius: "50%",
            data: data.obj,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return {
      maritallist,
      ...refData
    };
  }
});
</script>
<style lang="scss" scoped>
#populationLeftThree {
  width: 100%;
  height: 90%;
}
</style>
